import { notification } from 'antd';
import { useEffect, useState } from 'react';
import AxiosUtils from 'utils/axios-utils';
import { formatData } from 'utils/common';
import { extractList } from './utils';
import { mapStarError } from './star-error';

interface Options {
  refreshKey?: number;
  enabled?: boolean;
}

// Tải một danh sách (phân trang hoặc mảng trần) theo url + params; tải lại khi
// params đổi hoặc refreshKey tăng. `enabled=false` để chờ điều kiện (vd. vai trò).
export function usePagedList<T>(url: string, params: Record<string, any>, options: Options = {}) {
  const { refreshKey = 0, enabled = true } = options;
  const [items, setItems] = useState<T[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(enabled);
  const paramsKey = JSON.stringify(params);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    const fetchList = async () => {
      setLoading(true);
      try {
        const res = await AxiosUtils.get(url, formatData({ ...JSON.parse(paramsKey) }));
        const next = extractList<T>(res);
        if (!cancelled) {
          setItems(next.items);
          setTotal(next.total);
        }
      } catch (err) {
        if (!cancelled) notification.error({ message: mapStarError(err) });
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchList();
    return () => {
      cancelled = true;
    };
  }, [url, paramsKey, refreshKey, enabled]);

  return { items, total, loading, setItems };
}
